import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useOpSchedules from '@opsbase/react-gql-hooks/opschedule/useOpSchedules';
import Chip from '@opsbase/web-chips/Chip';
import CheckIcon from '@opsbase/web-icons/icons/CheckIcon';
import CrossIcon from '@opsbase/web-icons/icons/CrossIcon';
import Card from '@opsbase/web-layout/Card';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import Dots from '@opsbase/web-ui/Dots';
import Text from '@opsbase/web-ui/Text';
import React from 'react';
export function GeneralOverviewSection(props) {
    const { opDefinition, className } = props;
    const self = useSelf();
    let type = self.settings.opTypes.find(it => it.key === opDefinition.type);
    const { loading, data } = useOpSchedules({
        variables: { opDefinition: opDefinition.id },
        skip: !opDefinition,
    });
    const scheduled = loading ? undefined : !!(data === null || data === void 0 ? void 0 : data.length);
    return (React.createElement(Card, { classes: { root: className } },
        React.createElement(Vertical, { padding: true, gutter: true },
            React.createElement(Pane, { grow: true },
                React.createElement(Chip, { fullWidth: true, color: Palette.BorderGrey, label: type === null || type === void 0 ? void 0 : type.title })),
            React.createElement(Horizontal, { gutter: true },
                React.createElement(Pane, { grow: true },
                    React.createElement(Text, { variant: "h2" }, i18n.t('enabled'))),
                React.createElement(Pane, { grow: true },
                    React.createElement(CheckOrCross, { on: !!opDefinition.enabled }))),
            React.createElement(Horizontal, { gutter: true },
                React.createElement(Pane, { grow: true },
                    React.createElement(Text, { variant: "h2" }, i18n.t('is-adhoc'))),
                React.createElement(Pane, { grow: true },
                    React.createElement(CheckOrCross, { on: !!opDefinition.permitAdhoc }))),
            React.createElement(Horizontal, { gutter: true },
                React.createElement(Pane, { grow: true },
                    React.createElement(Text, { variant: "h2" }, i18n.t('scheduled'))),
                React.createElement(Pane, { grow: true },
                    React.createElement(CheckOrCross, { on: scheduled }))),
            React.createElement(Horizontal, { gutter: true },
                React.createElement(Pane, { grow: true },
                    React.createElement(Text, { variant: "h2" }, i18n.t('approval-required'))),
                React.createElement(Pane, { grow: true },
                    React.createElement(CheckOrCross, { on: !!opDefinition.approvalRequired }))),
            React.createElement(Horizontal, { gutter: true },
                React.createElement(Pane, { grow: true },
                    React.createElement(Text, { variant: "h2" }, i18n.t('scoring-enabled'))),
                React.createElement(Pane, { grow: true },
                    React.createElement(CheckOrCross, { on: !!opDefinition.isScoreEnabled }))))));
}
export default GeneralOverviewSection;
function CheckOrCross({ on }) {
    if (on === undefined)
        return React.createElement(Dots, { color: Palette.LavendarGrey });
    return on ? (React.createElement(CheckIcon, { color: Palette.BlackCoral })) : (React.createElement(CrossIcon, { color: Palette.LavendarGrey }));
}
